import { createStyles, makeStyles } from '@material-ui/core';
import { variables } from '../../styles';

export const useStyles = makeStyles(() =>
  createStyles({
    paper: {
      padding: '16px 32px 32px 32px',
      gap: 16,
    },
    datepiciker: {
      maxWidth: '47%',
      flexBasis: '47%',

      '@media (max-width: 550px)': {
        maxWidth: '100%',
        flexBasis: '100%',
      },
    },
    root: {
      width: '100%',
      cursor: 'pointer',

      '& .MuiOutlinedInput-root': {
        height: 56,
        gap: 16,
        borderRadius: 8,
        padding: 16,
        backgroundColor: '#FAFAFA',
        fontWeight: 400,
        color: '#030C21',
        cursor: 'pointer',
      },

      '& .MuiOutlinedInput-notchedOutline': {
        border: 'none',
        cursor: 'pointer',
      },
      '& .MuiOutlinedInput-input': {
        padding: 0,
        cursor: 'pointer',
      },
    },
    pickers: {
      flexDirection: 'row',

      '@media (max-width: 550px)': {
        flexDirection: 'column',
      },
    },
    picker: {
      '& .MuiPickersMonth-root': {
        height: 64,
        width: 64,
        flex: 'unset',
        marginLeft: 19,
        marginRight: 19,
      },
      '& .MuiPickersMonth-root.Mui-selected': {
        backgroundColor: '#030C21 !important',
        borderRadius: '50%',
        color: variables.white,
      },
      '& .MuiPickersToolbar-root': {
        backgroundColor: `${variables.mediumSeaGreen} !important`,
      },
    },
    errorMessage: {
      fontSize: 10,
      textAlign: 'end',
      color: variables.red,
      paddingTop: 5,
    },
  }),
);
